import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import './OutilTableRow.css';

export interface OutilTableRowProps {
	positive?: boolean;
	solde?: number;
	title: string;
}

const OutilTableRow = ({
	positive = true,
	solde = 0,
	title,
}: OutilTableRowProps) => (
	<div className="outilTableRow">
		<div className="outilTableRowName">{title}</div>
		<div
			className={`outilTableRowAmount ${positive ? 'positiveAmount' : 'negativeAmount'}`}
		>
			{formatMontant(solde)}
		</div>
	</div>
);

export default OutilTableRow;
